/**
 * Thể lệ WC — theo Figma node 105:457
 * https://www.figma.com/design/HLEbnxXldQA0r8t4ugTJBz/Untitled?node-id=105-457
 */

const sections = [
  {
    title: 'DỰ ĐOÁN TỈ SỐ MỖI TRẬN ĐẤU',
    body: 'Trước mỗi thời gian bắt đầu của các trận đấu trong giải World Cup 2026 hội viên tham gia dự đoán đúng tỉ số, sau khi kết thúc trận Hi88 sẽ thống kê và phát thưởng vào tài khoản hội viên hợp lệ.'
  },
  {
    title: 'DỰ ĐOÁN ĐỘI VÔ ĐỊCH',
    body: 'Dự đoán đội vô địch World Cup 2026: Từ 01/06/2026 00:00:00 đến 11/06/2026 23:59:59, hội viên chọn 1 đội duy nhất trong danh sách các đội tuyển chính thức tham dự; kết quả lấy theo đội thắng trận chung kết do FIFA công bố (bao gồm hiệp phụ và loạt sút luân lưu).'
  },
  {
    title: 'DỰ ĐOÁN VUA PHÁ LƯỚI',
    body: 'Dự đoán Vua phá lưới World Cup 2026 tại: Từ 01/06/2026 00:00:00 đến 11/06/2026 23:59:59, hội viên chọn 1 cầu thủ duy nhất trong danh sách các cầu thủ chính thức tham dự World Cup; kết quả lấy theo cầu thủ ghi nhiều bàn thắng nhất trong các trận đấu chính thức (bao gồm hiệp phụ, không tính loạt sút luân lưu) và theo công bố chính thức của FIFA (trường hợp đồng hạng cũng căn cứ theo kết quả FIFA).'
  },
  // {
  //   title: 'DỰ ĐOÁN ĐỘI ĐẦU TIÊN BỊ LOẠI',
  //   body: 'Từ 01/06/2026 00:00:00 đến 11/06/2026 23:59:59, hội viên chọn duy nhất 1 đội bóng trong danh sách các đội tham gia World Cup 2026 lựa chọn đội sẽ đầu tiên bị loại, sau khi có kết quả, hệ thống sẽ tự động cập nhật điểm thưởng vào tài khoản hội viên'
  // },
  {
    title: 'DỰ ĐOÁN CẦU THỦ XUẤT SẮC NHẤT',
    body: 'Dự đoán Cầu thủ xuất sắc nhất World Cup 2026 (Golden Ball): Từ 01/06/2026 00:00:00 đến `11/06/2026 23:59:59, hội viên chọn 1 cầu thủ duy nhất trong danh sách các cầu thủ chính thức tham dự World Cup; kết quả lấy theo danh hiệu Cầu thủ xuất sắc nhất (Golden Ball) do FIFA công bố chính thức.'
  },
  {
    title: 'DỰ ĐOÁN ĐỘI CÓ NHIỀU BÀN THẮNG NHẤT 1 TRẬN',
    body: 'Từ 01/06/2026 00:00:00 đến 11/06/2026 23:59:59, hội viên chọn duy nhất 1 đội bóng trong danh sách các đội tham gia World Cup 2026 lựa chọn đội có nhiều bàn thắng nhất 1 trận, sau khi có kết quả, hệ thống sẽ tự động cập nhật điểm thưởng vào tài khoản hội viên'
  }
  // {
  //   title: 'DỰ ĐOÁN ĐỘI NHẬN NHIỀU THẺ VÀNG NHẤT',
  //   body: 'Từ 01/06/2026 00:00:00 đến 11/06/2026 23:59:59, hội viên chọn duy nhất 1 đội bóng trong danh sách các đội tham gia World Cup 2026 lựa chọn đội sẽ nhận nhiều thẻ vàng nhất, sau khi có kết quả, hệ thống sẽ tự động cập nhật điểm thưởng vào tài khoản hội viên'
  // },
  // {
  //   title: 'DỰ ĐOÁN ĐỘI CÓ NHIỀU BÀN THẮNG NHẤT',
  //   body: 'Dự đoán đội có tổng số bàn thắng nhiều nhất tại World Cup 2026 : Từ 01/06/2026 00:00:00 đến 11/06/2026 23:59:59, hội viên chọn 1 đội bóng duy nhất trong danh sách các đội tham gia World Cup 2026. Kết quả được xác định theo đội có tổng số bàn thắng nhiều nhất trong thời gian thi đấu chính thức và hiệp phụ (không tính loạt sút luân lưu), căn cứ theo kết quả công bố chính thức của FIFA. Trường hợp có nhiều đội có cùng số bàn thắng cao nhất, kết quả sẽ được xác định theo đội diễn ra sớm nhất trong số các đội có cùng số bàn thắng đó.'
  // }
];

const promotionParagraphs = [
  'Sau khi có kết quả chính thức, hệ thống sẽ tự động kiểm tra và phát thưởng vào tài khoản hội viên trong vòng 24 giờ. Thành viên đăng nhập tài khoản bấm vào【Nhận thưởng】Bấm chọn【nhận】để nhận thưởng.',
  'Áp dụng cho hội viên hợp lệ có tổng nạp từ ngày hôm trước đến thời điểm dự đoán ≥ 300 điểm trước khi dự đoán.',
  'Mỗi một tài khoản, mỗi một IP, thiết bị đăng nhập, thẻ ngân hàng, Email và SĐT chỉ được dự đoán 1 lần/1 trận đấu. Dự đoán hợp lệ là dự đoán được gửi đúng thời gian quy định.',
  'Thành viên lạm dụng, vi phạm quy định công ty sẽ không được tham gia khuyến mãi này.',
  'Hi88 có quyền thay đổi, dừng hoặc hủy bỏ chương trình khuyến mãi này bất cứ lúc nào.',
  'Tham gia khuyến mãi đồng nghĩa với bạn đã đồng ý với Quy tắc và điều kiện khuyến mãi'
];

const gradientPillClass =
  'inline-flex max-w-full items-center justify-center rounded-[43px] border-2 border-white/50 bg-gradient-to-b from-[#26A9E0] to-[#1A7CA6] px-6 py-2.5 text-center shadow-[inset_0_1px_0_rgba(255,255,255,0.35),inset_0_-1px_0_rgba(0,0,0,0.12)]';

const RuleWC = () => {
  return (
    <div
      className="w-full mt-3 rounded-[20px] border-4 border-[#26A9E0] bg-[#F2FBF3] p-6 md:px-[46px] md:py-[24px]"
      role="region"
      aria-label="Thể lệ dự đoán World Cup 2026"
    >
      <div className="flex flex-col gap-[34px]">
        {sections.map(({ title, body }) => (
          <div key={title} className="flex flex-col gap-2">
            <div className="flex justify-center sm:justify-start">
              <div className={gradientPillClass}>
                <span className="font-sans text-base font-medium leading-tight text-white md:text-base">
                  {title}
                </span>
              </div>
            </div>
            <p className="text-left font-sans text-sm font-normal leading-[1.6] text-black md:text-base md:leading-[1.6]">
              {body}
            </p>
          </div>
        ))}

        <div className="flex flex-col gap-2">
          <div className="flex justify-center sm:justify-start">
            <div className="inline-flex max-w-full items-center justify-center rounded-[43px] bg-[#26A9E0] px-6 py-2.5 text-center">
              <span className="font-sans text-base font-medium uppercase leading-tight text-white md:text-base">
                Điều kiện khuyến mãi
              </span>
            </div>
          </div>
          <div className="flex flex-col gap-2">
            {promotionParagraphs.map((p, i) => (
              <p
                key={i}
                className="text-left font-sans text-sm font-normal leading-[1.6] text-black md:text-base md:leading-[1.6]"
              >
                {p}
              </p>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RuleWC;
